import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateContentRanking } from "../services/requests";
import type { UpdateContentRankingRequest } from "../schemas/auth";

export const useRanking = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateContentRankingRequest) => {
      return updateContentRanking(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listContents"] });
    },
    onError: (error) => {
      console.error("Ranking update failed:", error);
    },
  });
};
